import type { ReactNode } from 'react';
import React from 'react';

import { token } from '@atlaskit/tokens';
// eslint-disable-next-line @atlaskit/design-system/no-emotion-primitives -- to be migrated to @atlaskit/primitives/compiled – go/akcss
import { Box, xcss } from '@atlaskit/primitives';

type ContentMenuProps = {
	title: string;
	children: ReactNode;
};

export const ContentMenu = ({ title, children }: ContentMenuProps) => {
	return (
		<Box xcss={containerStyles}>
			<Box xcss={headingStyles}>{title}</Box>
			{children}
		</Box>
	);
};

const containerStyles = xcss({
	display: 'flex',
	flexDirection: 'column',
	height: '100%',
	maxHeight: 'min(calc(100vh - 26px), 760px)',
});

const headingStyles = xcss({
	height: 'size.300',
	paddingBlock: 'space.075',
	paddingLeft: 'space.075',
	color: 'color.text.subtle',
	font: token('font.body'),
	fontWeight: token('font.weight.bold'),
	display: 'flex',
	alignItems: 'center',
});
